document.querySelector('header .burger').addEventListener('click', () => {
    document.body.classList.toggle('menu-open');
});
